import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ColorInternarRequest from "@/components/functionals/ColorInternarRequest";

const columns = [
  {
    prop: "Id",
    label: "No",
    minWidth: 80,
    fixed: true,
    sortable: true,
    formatter: ColorInternarRequest
  },
  {
    prop: "corta",
    label: "Descripcion",
    sortable: true,
    minWidth: 250
  },
  {
    prop: "Responsable",
    label: "Responsable",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "ResponsableImage"
    }
  },
  {
    prop: "CreateBy",
    label: "Creado Por",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "CreatorImage"
    }
  },
  {
    prop: "SlaDaysToResponse",
    label: "Sla (dias)",
    sortable: true,
    minWidth: 120
  },
  {
    prop: "DiasRetrasadosSla",
    label: "Atraso",
    sortable: true,
    minWidth: 120
  }
];

export default columns;
